// extracted by mini-css-extract-plugin
export var chevronIcon = "_50-2";
export var teamName = "_50-1";
export var teamSwitcherButton = "_50-0";